import React from "react";
import ObsIframe from "../../iframe-component/onboarding/ObsIframe";

const Sales = () => {
  return <ObsIframe path="/sales" />;
};

export default React.memo(Sales);
